module.exports = __webpack_public_path__ + "img/material-title.00a91add.png";